import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate, Trans } from "react-i18next";

import Button from "components/Button";
import Loader, { LoaderStyle } from "components/Loader";

import style from "./style.css";

@translate()
export default class CheckIp extends Component {
  render() {
    const { isDisabled, isLoading, onClick, ipPolicy } = this.props;
    return (
      <div className={style.root}>
        <Button
          type="button"
          onClick={onClick.bind(this)}
          isDisabled={isDisabled}>
          {isLoading && <Loader rootClassname={style.loader} style={LoaderStyle.WHITE} />}
          {!isLoading && <Trans>_cgn_form_component_check_ip_label_button</Trans>}</Button>
        {ipPolicy.success === true && (
          <span className={style.errorSuccess}>
            <Trans>{ipPolicy.message}</Trans>
          </span>
        )}
        {ipPolicy.success === false && (
          <span className={style.errorMessage}>
            <Trans>{ipPolicy.message}</Trans>
          </span>
        )}
      </div>
    );
  }
}

CheckIp.propTypes = {
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  rootClassname: PropTypes.string,
  ipPolicy: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Cgn/CheckIp/index.js